'use strict';

angular.module('shiftTraderApp')
  .directive('saScheduleLineItem', function () {
    return {
      templateUrl: 'views/directives/saScheduleLineItem.html',
      restrict: 'A',
      scope: {
        workPeriod:'=saScheduleLineItem'
      },
      controller: ['$scope', '$timeout', '$state', function ($scope, $timeout, $state) {
        var calcAndSetWidth = function() {
          $scope.bgWidth = { width: $scope.workPeriod.$calcPercentWorked() + '%'};
          $timeout(calcAndSetWidth, 10000);
        };

        calcAndSetWidth();
        $scope.$state = $state;
      }]
    };
  });
